// vendor
import { Injectable } from '@angular/core';

// models

export interface ComponentConfig {
  inputs?: Object;
  outputs?: Object;
}

@Injectable({
  providedIn: 'root',
})
export class DomService {
  // from css-tricks.com/using-css-transitions-auto-dimensions/#aa-technique-3-javascript
  collapseSection(element: HTMLElement, transitionTiming = '0.25s cubic-bezier(0.42, 0, 0.58, 1)') {
    // get the height of the element's inner content, regardless of its actual size
    var sectionHeight = element.scrollHeight;

    element.style.transition = '';
    element.ariaHidden = 'true';

    // on the next frame (as soon as the previous style change has taken effect),
    // explicitly set the element's height to its current pixel height, so we
    // aren't transitioning out of 'auto'
    requestAnimationFrame(function () {
      element.style.height = sectionHeight + 'px';
      element.style.overflow = 'hidden';
      element.style.transition = `height ${transitionTiming}`;

      // on the next frame (as soon as the previous style change has taken effect),
      // have the element transition to height: 0
      requestAnimationFrame(function () {
        element.style.height = 0 + 'px';
      });
    });
  }

  isElementInViewport(el: HTMLElement) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) /* or $(window).height() */ &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
    );
  }

  /**
   * Scrolls to first form error if it isn't already in viewport
   */
  scrollToFirstFormError(selector = '.be-input-label-error') {
    const firstErrorOccurrence: HTMLElement = document.querySelector(selector);
    if (firstErrorOccurrence && !this.isElementInViewport(firstErrorOccurrence)) {
      firstErrorOccurrence.scrollIntoView({ behavior: 'smooth' });
      firstErrorOccurrence.focus({ preventScroll: true });
    }
  }
}
